import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { useHistory } from 'react-router'
import { isIOS } from 'react-device-detect'
import { ColorRing } from 'react-loader-spinner'

import styles from '../Playdynamex/MainPlaydynamex.module.css'
import MakeHeader from '../ReusableComponents/Header/MakeHeader'
import getBackendImage from '../../source/imageUtil'

const BACKEND_URL = process.env.REACT_APP_API_BASE

const isJwtExpired = (token) => {
    try {
        const payload = JSON.parse(atob(token.split('.')[1]))
        return payload.exp * 1000 < Date.now()
    } catch {
        return true
    }
}

const MainPlaymex = (props) => {
    const history = useHistory()
    const deviceVersion = sessionStorage.getItem('deviceVersion') || '1.0.0'

    const [projects, setProjects] = useState([])
    const [loading, setLoading] = useState(true)
    const [showGuestBanner, setShowGuestBanner] = useState(false)

    // --- Grade Sidebar Tracking ---
    const [activeGrade, setActiveGrade] = useState('Grade 1')
    const gradesList = [
        'Grade 1',
        'Grade 2',
        'Grade 3',
    ]

    useEffect(() => {
        const checkAuthStatus = () => {
            const userJwt = localStorage.getItem('userJWT')
            if (userJwt && isJwtExpired(userJwt)) {
                localStorage.removeItem('userJWT')
                sessionStorage.removeItem('guestWarningDismissed')
                setShowGuestBanner(true)
                return
            }
            const warningDismissed = sessionStorage.getItem('guestWarningDismissed')
            if (!userJwt && !warningDismissed) {
                setShowGuestBanner(true)
            }
        }

        checkAuthStatus()
        const interval = setInterval(checkAuthStatus, 10000)
        return () => clearInterval(interval)
    }, [])

    const handleDismissWarning = () => {
        sessionStorage.setItem('guestWarningDismissed', 'true')
        setShowGuestBanner(false)
    }

    // Secret Admin Shortcut
    useEffect(() => {
        let buffer = ''
        let lastKeyTime = Date.now()

        const handleKeyDown = (e) => {
            const isMac = navigator.userAgent.toUpperCase().includes('MAC')
            const isMacShortcut = isMac && e.metaKey && e.shiftKey && e.key.toLowerCase() === 'y'
            const isWinShortcut = !isMac && e.ctrlKey && e.shiftKey && e.key.toLowerCase() === 'y'

            if (isMacShortcut || isWinShortcut) {
                e.preventDefault()
                history.push('/playmex-main-admin') // Update to your route name
                return
            }

            const now = Date.now()
            if (now - lastKeyTime > 3000) buffer = ''
            lastKeyTime = now

            if (e.key.length === 1) {
                buffer += e.key.toLowerCase()
                if (buffer.includes('admin')) {
                    history.push('/playmex-main-admin')
                    buffer = ''
                }
                if (buffer.length > 10) buffer = buffer.slice(-10)
            }
        }
        window.addEventListener('keydown', handleKeyDown)
        return () => window.removeEventListener('keydown', handleKeyDown)
    }, [history])

    useEffect(() => {
        fetch(`${BACKEND_URL}/api/playmex-standalone`)
            .then((res) => res.json())
            .then((data) => {
                setProjects(data.projects || [])
                setLoading(false)
            })
            .catch((err) => {
                console.error('Failed to load projects:', err)
                setLoading(false)
            })
    }, [])

    // --- Live filtering tracking logic ---
    const filteredProjects = projects.filter((proj) => {
        // If database entry lacks an explicit grade field, default it safely to Grade 1
        const projectGrade = proj.grade || 'Grade 1'
        return projectGrade.toLowerCase() === activeGrade.toLowerCase()
    })

    return (
        <>
            <div className={styles.Main_Select}>
                <div className={styles.Select_Headers}>
                    <MakeHeader
                        title={`Mex Projects`}
                        titlePosition="left"
                        help_btnPosition="right"
                        isGoBack={!isIOS}
                        goBack={isIOS ? undefined : () => history.push('/kitSelection')}
                        showAccountSetting={true}
                        showHelp={true}
                        showBluetoothBtn={false}
                    />
                </div>

                <div className={styles.TokiKits_Body}>
                    {/* --- Sidebar Structure --- */}
                    <div className={styles.Sidebar}>
                        {gradesList.map((grade) => (
                            <button
                                key={grade}
                                className={`${styles.SidebarItem} ${activeGrade === grade ? styles.ActiveSidebarItem : ''}`}
                                onClick={() => setActiveGrade(grade)}
                            >
                                {grade}
                            </button>
                        ))}
                    </div>

                    {/* --- Grid Container Wrapper --- */}
                    <div className={styles.GridContainer}>
                        {loading && (
                            <div
                                style={{ textAlign: 'center', padding: '40px' }}
                            >
                                <ColorRing
                                    visible={true}
                                    height="60"
                                    width="60"
                                    colors={[
                                        '#e15b64',
                                        '#f47e60',
                                        '#f8b26a',
                                        '#abbd81',
                                        '#849b87',
                                    ]}
                                />
                            </div>
                        )}

                        {!loading &&
                            filteredProjects.map((proj) => (
                                <div
                                    key={proj.id}
                                    className={styles.TokiKit_Card}
                                    onClick={() =>
                                        history.push(
                                            `/playmex?projectId=${proj.id}`
                                        )
                                    }
                                    style={{
                                        opacity: props.isConnecting ? 0.5 : 1,
                                    }}
                                >
                                    <div className={styles.TokiKit_CardImg}>
                                        <img
                                            src={getBackendImage(proj.image)}
                                            alt={proj.title}
                                        />
                                    </div>
                                    <p className={styles.TokiKit_CardName}>
                                        {proj.title}
                                    </p>
                                </div>
                            ))}

                        {!loading && filteredProjects.length === 0 && (
                            <div
                                style={{
                                    textAlign: 'center',
                                    color: '#666',
                                    gridColumn: '1 / -1',
                                }}
                            >
                                No projects found for {activeGrade}.
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

const mapStateToProps = (state) => ({
    isConnecting: state.isConnecting,
})

export default connect(mapStateToProps)(MainPlaymex)